import { useEffect, useState } from 'react';
import { usePage } from '@inertiajs/react';
import { assetUrl } from '@Shared/Helpers/Utilities';

const WidgetScript = () => {
    const currentRoute = usePage().props.current_route;
    const auth = usePage().props.auth?.customer;

    const mainCampaignCode = import.meta.env.VITE_MAIN_CAMPAIGN_CODE;

    const [mobile, setMobile] = useState(false);

    const showWidgetpages = [
        'home',
        'web.integrations.index',
        'web.integrations.hubspot',
        'web.integrations.salesforce',
        'web.integrations.monday',
        'web.integrations.zoho',
        'web.integrations.pipedrive',
        'web.integrations.make',
        'web.integrations.stripe',
        'web.integrations.intercom',
        'web.integrations.webhook-api',
        'web.integrations.zapier',
        'web.integrations.servicetitan',
        'web.pages.our_software',
        'web.pages.features',
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.device === 'mobile') {
                setMobile(true);
            } else {
                setMobile(false);
            }
        }
    }, []);

    useEffect(() => {
        if (!showWidgetpages.includes(currentRoute)) {
            return;
        }

        if (window.device === 'mobile') {
            return;
        }

        if (document.getElementById('rf-launcher') || document.getElementById('rf-widget')) {
            return;
        }

        window.RF = {
            user: {
                first_name: auth?.name || '',
                email: auth?.email || '',
            },
        };

        const script = document.createElement('script');
        script.id = 'rf-script';
        script.src = assetUrl(`/assets/js/widget.js?code=${mainCampaignCode}`);
        script.async = true;
        document.body.appendChild(script);

        return () => {
            const existingScript =
                document.getElementById('rf-launcher') ??
                document.getElementById('rf-widget');
            if (existingScript) {
                document.body.removeChild(existingScript);
            }
        };
    }, [auth, currentRoute, mobile]);

    return null;
};

export default WidgetScript;
